<template>
  <v-container fluid class="pa-0" style="height: 100%;">

    <MachinePickerPane v-if="showPicker" :key="CustomerId" :preSelected="selectedMachines"
      :lockedFilters="{ CustomerId: CustomerId }" :customerId="CustomerId" :multiple="!!(CustomerId)"
      :allowSelectAll="!!(CustomerId)" :selectText="$t('servicesystem.common_objects.machine.add_to_job')"
      :quickClickFunction="item => handleQuickAdd([item])" :onSelectMethod="sf => handleSelect(sf)" ref="picker">
    </MachinePickerPane>

    <QScroll v-else :list="machines" :loading="loading" :skeletonloading="true" :height="contentHeight" :minheight="contentHeight"   :initLimit="10">

      <template v-slot:prepend-item>
        <section-header :fontsize="'h2'" :icon="'$machine'" :title="$t('servicesystem.common_objects.machine.machines')"
          :invalid="!loading && (!isNew && (!Machines || !Machines[0]))" :leftpad="'ml-4'"
          style="padding-top: 6px !important; padding-bottom: 6px !important; background-color: white;">
          <template v-slot:button>
            <v-btn v-if="checkPermission('Actions', 'addSubjob')" :disabled="disabled" small
              :color="showPicker ? 'error' : 'primary'" outlined class="font-weight-bold mr-3" @click="openPicker()">
              <v-icon :class="isPhoneBool ? '' : 'mr-2'" size="20">{{ showPicker ? 'mdi-close' :
                'mdi-plus' }}</v-icon>
              {{ isPhoneBool ? '' : showPicker ? $t('servicesystem.common_objects.commonterms.cancel') :
              $t('servicesystem.common_objects.commonterms.add_machine') }}
            </v-btn>
          </template>
        </section-header>
      </template>

      <template v-slot:list-item="{ item }">
        <machine-card :subjobId="item.Id" :isNew="isNew" :disabled="disabled" class="mx-1">
        </machine-card>
      </template>

      <template v-slot:empty-filtered-list>
        <EmptyPage :icon="'mdi-filter-remove'"
          :title="$t('servicesystem.common_objects.fallbackterms.empty_filter', { okey: $t('servicesystem.common_objects.machine.machines').toLowerCase() })"
          :message="$t('servicesystem.common_objects.fallbackterms.empty_filter_body')" class="ignoreodd">
        </EmptyPage>
      </template>

      <template v-slot:empty-list>
        <div class="pl-3 py-2" :class="!isNew ? 'error--text' : ''">
          {{ $t('servicesystem.common_objects.fallbackterms.no_machines') }}
        </div>
      </template>
    </QScroll>

    <AddMachineJobDialog :externaltrigger="addTrigger" :item="newSubjobDetails" :isNew="isNew"
      :prerequisiteLoading="gatheringMachinesLoading" :saveFunction="bulkAddToJob">
    </AddMachineJobDialog>

  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SectionHeader from "@/components/ExpancionPanels/Parts/SectionHeader.vue";
import MachineCard from "@/views/job/newjob/cards/machines/MachineJobCard.vue";
import MachinePickerPane from "./MachinePickerPane2.vue";
import QScroll from "@/components/Sections/Containers/QScroll.vue";
import EmptyPage from "@/components/Sections/EmptyPage.vue";
import AddMachineJobDialog from "@/components/Dialogs/AddMachineJobDialog.vue";

export default {
  name: "MachineCardList",
  props: ["machines", "isNew", "disabled"],
  components: {
    SectionHeader,
    MachineCard,
    MachinePickerPane,
    QScroll,
    EmptyPage,
    AddMachineJobDialog,
  },
  mixins: [clientAPI],

  data() {
    return {
      customerList: [],
      addTrigger: 1,
      selectionFilter: null,
      newSubjobDetails: {},
      machineList: [],
      gatheringMachinesLoading: false
    };
  },

  mounted() {
    this.$store.dispatch("JobHub/JobPreview/setPreviewMachine", null);
  },

  methods: {
    openPicker() {
      this.$router.replace({ params: this.$route.params, query: { ...this.$route.query, picker: 'machine' } });
    },

    handleQuickAdd(itemArr) {
      var selectionFilter = {
        PrependItemIdList: itemArr.map(i => i.Id),
      };
      this.handleSelect(selectionFilter);
    },

    async handleSelect(selectionFilter) {
      //console.log("Handling selection:", JSON.parse(JSON.stringify(selectionFilter)));
      this.selectionFilter = Object.assign({}, selectionFilter);
      this.newSubjobDetails = this.getfreshSubJobDetails();
      this.addTrigger++;
      this.gatheringMachinesLoading = false;
      //load selection in the background while user sets details if new as the machines are kept in the FE
      if (this.isNew) {
        this.gatheringMachinesLoading = true;
        //console.log("Loading machine list...");
        this.machineList = await clientAPI.methods.gatherMachineListFromSelection(this.selectionFilter);
        console.log("Loaded machine list:", this.machineList);
        this.gatheringMachinesLoading = false;
      }
    },

    getfreshSubJobDetails() {
      var config = {
        New: true,
        Id: null, //new Date().getTime(),
        ParentId: this.$route.params.jobId,
        CustomerComment: '',
        SupplierFailureCodeId: null,
        NoInvoice: false,
        JobTypeId: this.defaultJobTypeId,
        JobCategoryId: this.defaultJobCategoryId,
        SupplierId: null,
        Machine: null,
      };
      /*
      //provide the supplier id only if all machines are from the same supplier (used for faillure code)
      var supplierIds = this.selectArr?.map((machine) => machine.MachineModel?.Supplier?.Id);
      //console.log('supplierIds', supplierIds);
      if (supplierIds && [...new Set(supplierIds)].length == 1) {
        config.SupplierId = supplierIds[0];
      }
      */
      return config;
    },

    async bulkAddToJob(propperties) {
      //if new job that does not exist in the BE
      if (this.isNew) {
        var machines = this.machineList;
        if (!this.CustomerId) {
          this.$store.dispatch("JobHub/JobCustomer/getCustomer", machines[0].CustomerId);
        }
        var newlist = [];

        machines.forEach(element => {
          var subjob = Object.assign({}, propperties);
          subjob.Machine = Object.assign({}, element);
          subjob.Id = Date.now().toString(36) + Math.random().toString(36).substr(2);
          newlist.push(subjob);
        });

        this.$store.dispatch("JobHub/JobSubjobs/addSubjobs", newlist);
      }
      //if Parent job already exist in BE
      else {
        const updateDto = Object.assign({}, propperties);
        var dto = { SelectionFilter: this.selectionFilter, Updates: updateDto };
        await clientAPI.methods.bulkAddMachineJobs(dto);
        this.$router.replace({ query: { ...this.$route.query, timestamp: this.getNowTime(this.oldTimeFormat) } });
      }
      if (this.$refs.picker) {
        this.$refs.picker.close();
      }
    },
  },

  computed: {
    defaultJobCategoryId() {
      var stored = this.globalSettings?.DefaultJobCategoryId;
      return stored ? stored : null
    },

    defaultJobTypeId() {
      return this.JobDetails?.JobTypeId;
    },

    JobDetails() {
      return this.$store.getters["JobHub/JobParentjob/JobDetails"];
    },

    globalSettings() {
      return this.$store.state.GlobalSettings;
    },

    CustomerId() {
      return this.Customer && this.Customer.Id;
    },
    Customer() {
      return this.$store.getters["JobHub/Customer"];
    },

    PreviewMachine() {
      return this.$store.getters["JobHub/PreviewMachine"];
    },

    Machines() {
      return this.$store.getters["JobHub/Subjobs"];
    },

    selectedMachines() {
      return this.Machines?.map((machine) => machine.Machine);
    },

    loading() {
      return this.$store.getters["JobHub/Subjobs"] == null
    },

    showPicker() {
      return this.$route.query.picker == 'machine';
    },

    contentHeight() {
      return this.$store.getters['navstore/ContentContainerHeight'];
    },
  },

  watch: {}
};
</script>

<style lang="scss" scoped>
.hei2 {
  background-color: rgb(248, 248, 248) !important;
  overflow-y: scroll;
  position: relative;
  max-height: inherit;
}

.conti {
  max-height: calc(100vh - 100px);
}

.conti2 {
  max-height: calc(100vh - 210px);
}

.fillheight33 {
  max-height: inherit;
  min-height: 100%;
}
</style>